import { minLength, maxLength, emailPattern, emailPatternError } from '../../utils/form-validations';

const MIN_LENGTH_NAME = 1;

export const userFormDefaultFields = {
  firstName: '',
  lastName: '',
  email: '',
  roles: '',
};

export const userFormUISchema = [
  { id: 1, label: 'First Name', name: 'firstName', type: 'input', required: true },
  { id: 2, label: 'Last Name', name: 'lastName', type: 'input', required: true },
  { id: 3, label: 'Email', name: 'email', type: 'input', required: true },
  { id: 4, label: 'Role', name: 'roles', type: 'select', required: true },
];

export const userFormSchema = {
  type: 'object',
  properties: {
    firstName: { type: 'string', minLength: MIN_LENGTH_NAME, maxLength },
    lastName: { type: 'string', minLength: MIN_LENGTH_NAME, maxLength },
    email: {
      type: 'string',
      minLength,
      maxLength,
      pattern: emailPattern,
      errorMessage: {
        pattern: emailPatternError,
      },
    },
    roles: { type: 'array', minItems: 1, items: { type: 'object' } },
  },
  required: ['firstName', 'lastName', 'email', 'roles'],
  additionalProperties: true,
};
